export default `
avatar.png
size:1932,1069
filter:Linear,Linear
artist-bg
bounds:669,715,477,352
artist-brush
bounds:256,113,194,182
offsets:1,1,196,184
avatar
bounds:2,297,448,448
offsets:1,1,450,450
coffe
bounds:1319,30,193,139
offsets:1,1,195,141
figure
bounds:1714,128,203,227
offsets:1,1,205,229
food-cheese
bounds:452,124,123,95
offsets:1,1,125,97
food-onion
bounds:1437,527,101,116
offsets:1,1,103,118
food-shimp
bounds:487,2,143,120
offsets:1,1,145,123
hat-artist
bounds:1085,463,350,180
offsets:1,1,352,182
hat-cooker
bounds:2,2,293,252
offsets:1,1,295,254
rotate:90
hat-game-design
bounds:1714,357,254,216
offsets:2,2,258,220
rotate:90
keyboard
bounds:1540,43,568,172
rotate:90
monitor-outside
bounds:1148,645,474,422
moustache
bounds:1086,79,231,90
pointing-hand
bounds:632,23,108,158
offsets:1,1,110,160
rotate:90
salt-bottle
bounds:1714,20,106,191
offsets:1,1,108,193
rotate:90
screen-animation-emoji
bounds:256,3,108,229
rotate:90
screen-animator
bounds:1624,613,454,292
rotate:90
screen-artist
bounds:629,421,454,292
screen-dev
bounds:629,133,455,286
offsets:1,1,457,288
screen-game-design
bounds:1086,171,452,290
offsets:1,1,454,292
wok-back
bounds:2,747,665,320
offsets:1,1,667,323
wok-front
bounds:452,221,524,175
offsets:1,1,527,177
rotate:90
`;
